import http from './interface'
import { ITimeQuantumBookingModel } from '@/pages/seat/data/seatModel'
import { UserModule } from '@/store/modules/user'

// 得到某一个月的日历信息（酿酒师）
export const getWinemakerOneMonthAppointmentData = (date: string) => {
  return http.get(
    `/api/v3/wineries/${UserModule.wineryId}/products/winemaker-experience-tickets/inventories?month=${date}`
  )
}